<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Antrian" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <center class="py-3">
            <h3 class="mb-4">Nomor antrian Anda adalah:</h3>
            <div class="row mb-4">
              <div class="col-md-4 offset-md-4 px-5">
                <div class="card p-2">
                  <h1 class="my-3 text-secondary">U-135</h1>
                </div>
              </div>
            </div>
            <h4 class="font-body text-muted mb-2">
              Saat ini antrian berada pada urutan
              <strong class="text-primary">U-130</strong>
            </h4>
            <p>
              Silakan ambil nomor antrian Anda yang telah dicetak dan menuju ke
              meja pendaftaran
            </p>
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <div class="card p-3">
                      <p class="mb-0">
                        Jika Anda adalah pasien baru, Anda dapat melakukan
                        pengisian data pasien secara mandiri melalui komputer
                        'DAFTAR MANDIRI' yang ada di dekat meja pendaftaran.
                        Silakan hubungi petugas kami untuk membantu Anda
                        melakukan pendaftaran secara mandiri
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="text-muted">Menutup secara otomatis dalam:</p>
            <h2 class="counter mt-2 mb-4">{{ counter }}</h2>
            <router-link to="/antrian/pasien" class="btn btn-primary btn-lg"
              >SELESAI</router-link
            >
          </center>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
let counter = 30;

export default {
  name: "AntrianSelesai",
  components: {
    Navbar,
    Sidebar,
  },
  data: () => {
    return { fromUrl: "", plainUrl: "", counter: counter };
  },
  mounted() {
    let countdown = setInterval(() => {
      if (this.counter > 0) {
        this.counter -= 1;
      } else {
        window.location.href = "/#/antrian/pasien";
        clearInterval(countdown);
      }
    }, 1000);
  },
};
</script>